import {useRef} from "react";
import L from "leaflet";
import "proj4leaflet";
import "leaflet-draw";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import {
    useCoordinatesMapControl,
    useScaleMapControl,
    useResetViewMapControl,
} from "./controls";

export const mapOverlayPanes = [...Array(15).keys()].map(i => "overlayPane" + i);

const defaultCenter = [42.851806, -7.976074];
const defaultZoom = 5;

export function useMap(crs = null) {
    const mapRef = useRef(null);
    const mapObjectRef = useRef(null);
    const {addCoordinatesMapControl} = useCoordinatesMapControl();
    const {addScaleMapControl} = useScaleMapControl();
    const {addResetViewMapControl} = useResetViewMapControl(defaultCenter, defaultZoom);

    const mapOptions = {
        minZoom: 3,
        maxZoom: 16,
        maxBounds: [
            {lng: -24, lat: 72},
            {lng: 35, lat: 21},
        ],
        center: defaultCenter,
        zoom: defaultZoom,
        zoomSnap: 0, // http://leafletjs.com/reference.html#map-zoomsnap
    };
    if (crs) {
        mapOptions["crs"] = crs;
    }

    const createMap = () => {
        const map = L.map(mapRef.current, {...mapOptions});

        addCoordinatesMapControl(map);
        addScaleMapControl(map);
        addResetViewMapControl(map);

        // addDownloadMapControl(map);

        // Add a series of custom panes for overlay layers
        mapOverlayPanes.forEach((p, i) => {
            map.createPane(p);
            map.getPane(p).style.zIndex = (400 + (i + 1) * 5).toString();
        });

        mapObjectRef.current = map;

        return map;
    };

    return {mapRef, createMap};
}
